import sub from 'date-fns/sub';

export const getDefaultDates = () => {
  const now = new Date();
  const dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).toISOString();
  const threeDaysAgo = sub(now, { days: 3 });
  const dateFrom = new Date(
    threeDaysAgo.getFullYear(),
    threeDaysAgo.getMonth(),
    threeDaysAgo.getDate(),
    0,
    0,
    0,
    0,
  ).toISOString();

  return {
    dateFrom,
    dateTo,
  };
};

export const getDateRange = (date: Date) => {
  const dateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString();
  const dateFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString();

  return {
    dateFrom,
    dateTo,
  };
};

export const lastFourDays = getDefaultDates();
